import React, { useState, useEffect } from 'react'
import { useStateValue } from './StateProvider';
import { useParams } from "react-router-dom";
import "./css/ProductDetail.css";
import { Avatar } from '@mui/material';
import Product from "./Product";
import { firestore } from '../firebase';

function ProductDetails() {
  const[{basket}, dispatch] = useStateValue();
  const { title } = useParams();
  const [productData, setProductData] = useState([]);

  useEffect(() => {
    const productInfoRef = firestore.collection("products").doc(title);
    productInfoRef
    .get()
    .then((doc) => {
      const data = doc.data();
      setProductData(data);
      console.log("Product Details")
    })
    .catch(error => console.log(error.message));
  },[title])

  const addToBasket = () => {
    if (productData?.productName && productData?.productPrice && productData?.productImage?.[0]) {
      dispatch({
        type: 'ADD_TO_BASKET',
        item: {
          id: productData.id,
          title: productData.productName,
          price: productData.productPrice,
          image: productData.productImage[0],
        }
      });
    } else {
      console.warn('Product data or required properties are null. Item not added to the basket.');
    }
  };
  

  const productImages = productData?.productImage && [
    productData?.productImage?.[0],
    productData?.productImage?.[1],
    productData?.productImage?.[2],
    productData?.productImage?.[3],
    productData?.productImage?.[4],
  ];

  const [imageSlide, setImageSlide] = useState("");

  useEffect(() => {
    setImageSlide(productImages?.productImage?.[0]);
  }, []);

  const changeImage = (newImage) => {
    setImageSlide(newImage);
  };

  return (
    <div className="product-details">
      <div className='product-infos'>
        <div className='product-picks'>
        <div className='product-images'>
          <img src={imageSlide || productData?.productImage?.[0]} alt={productData?.productName} />
        </div>
        <div className='other-images'>
          {productImages?.map((image, index) => (
            <Avatar onClick={() => changeImage(image)} src={image} key={index}/>
          ))}
          </div>
        </div>
        <div className='product-des'>
          <h1> {productData?.productName} </h1>
          <h3> ${productData?.productPrice} </h3>
          <p><span style={{fontWeight: "bold"}}>Product Category:</span> {productData?.productCategory}</p>
          <p><span style={{fontWeight: "bold"}}>Delivery:</span> {productData?.productDelivery} </p>
          <p><span style={{fontWeight: "bold"}}>Product Description:</span> {productData?.productDesc} </p>
          <button onClick={addToBasket}>ADD-TO-CART</button>
        </div>
      </div>

      <h2 style={{textAlign: "center", textDecoration: "underline"}}>Related Products</h2>
      <div className='related-row'>
        {/*{productData.map((data) => (
              <Product key={data?.index} id={data?.id} image={data?.productImage} title={data?.title} price={data?.price}/>
        ))}*/}
      </div>
      <br />
    </div>
  )
}

export default ProductDetails